import api from '../config/api';

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  phone?: string;
  photo?: string;
  role: string;
  section?: 'VCN' | 'HDR' | 'SANTE';
  is_active?: boolean;
  date_joined: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface RegisterData {
  username?: string; // Optionnel, sera généré automatiquement si non fourni
  email: string;
  password: string;
  password2: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  section?: 'VCN' | 'HDR' | 'SANTE';
}

export interface LoginResponse {
  user: User;
  access: string;
  refresh: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await api.post('/accounts/login/', { email, password });
    return response.data;
  },

  register: async (data: RegisterData): Promise<LoginResponse> => {
    const response = await api.post('/accounts/register/', data);
    return response.data;
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await api.post('/accounts/forgot-password/', { email });
    return response.data;
  },

  resetPassword: async (email: string, code: string, new_password: string, new_password2: string): Promise<{ message: string }> => {
    const response = await api.post('/accounts/reset-password/', {
      email,
      code,
      new_password,
      new_password2
    });
    return response.data;
  },

  getProfile: async (): Promise<User> => {
    const response = await api.get('/accounts/profile/');
    return response.data;
  },

  updateProfile: async (data: Partial<User>): Promise<User> => {
    const response = await api.put('/accounts/profile/', data);
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await api.get('/accounts/me/');
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<{ access: string }> => {
    const response = await api.post('/accounts/token/refresh/', { refresh: refreshToken });
    return response.data;
  },
};
